import { createContext } from 'react';

// Disabling the rule to allow for `Type` suffix, to differentiate from the Context object.
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions

/**
 * Context for the panel splitter. Only internally exported.
 */
export var PanelSplitterContext = /*#__PURE__*/createContext(null);